const UFsBrasil = {
    norte: [
        { code: 'AC', name: 'Acre' },
        { code: 'AL', name: 'Amapá' },
        { code: 'AM', name: 'Amazonas' },
        { code: 'PA', name: 'Pará' },
        { code: 'RO', name: 'Rondônia' },
        { code: 'RR', name: 'Roraima' },
        { code: 'TO', name: 'Tocantins' },
    ],
    nordeste: [
        { code: 'BA', name: 'Bahia' },
        { code: 'CE', name: 'Ceará' },
        { code: 'MA', name: 'Maranhão' },
        { code: 'PB', name: 'Paraíba' },
        { code: 'PE', name: 'Pernambuco' },
        { code: 'PI', name: 'Piauí' },
        { code: 'RN', name: 'Rio Grande do Norte' },
        { code: 'SE', name: 'Sergipe' },
    ],
    centro_oeste: [
        { code: 'DF', name: 'Distrito Federal' },
        { code: 'GO', name: 'Goiás' },
        { code: 'MT', name: 'Mato Grosso' },
        { code: 'MS', name: 'Mato Grosso do Sul' },
    ],
    sudeste: [
        { code: 'ES', name: 'Espírito Santo' },
        { code: 'MG', name: 'Minas Gerais' },
        { code: 'RJ', name: 'Rio de Janeiro' },
        { code: 'SP', name: 'São Paulo' },
    ],
    sul: [
        { code: 'PR', name: 'Paraná' },
        { code: 'RS', name: 'Rio Grande do Sul' },
        { code: 'SC', name: 'Santa Catarina' },
    ],
};

export default UFsBrasil;
